import React from "react";
import Typography from "@mui/material/Typography";

export default function AcompanhamentoCargaGridCarregamentosCIFModalTopo() {
  return (
    <React.Fragment>
      <div className="containerTitle">
        <Typography
          variant="h5"
          fontFamily={"Co Headline Regular"}
          gutterBottom
          align="left"
          marginLeft="15px"
        >
          Carregamentos CIF
        </Typography>
      </div>
    </React.Fragment>
  );
}
